function izInitBlogPost() {
  var rtes = document.querySelectorAll('.iz-rte');
  rtes.forEach(function (rte) {
    // 1) Cajas: "Lo esencial", "Preguntas frecuentes", "En resumen"
    Array.prototype.slice.call(rte.querySelectorAll('h2')).forEach(function (h) {
      var t = h.textContent.trim().toLowerCase();
      var wrap = null;
      if ((t === 'lo esencial' || t === 'en pocas palabras' || t === 'resumen rápido') && h.nextElementSibling && h.nextElementSibling.tagName === 'UL') {
        wrap = document.createElement('div');
        wrap.className = 'iz-essentials';
        h.parentNode.insertBefore(wrap, h);
        wrap.appendChild(h);
        wrap.appendChild(wrap.nextElementSibling);
        return;
      }
      if (t.indexOf('preguntas frecuentes') === 0 || t === 'faq' || t === 'faqs') {
        wrap = document.createElement('div');
        wrap.className = 'iz-faq';
      } else if (t === 'en resumen' || t === 'conclusión' || t === 'conclusion' || t === 'resumen') {
        wrap = document.createElement('div');
        wrap.className = 'iz-summary';
      }
      if (wrap) {
        h.parentNode.insertBefore(wrap, h);
        wrap.appendChild(h);
        while (wrap.nextElementSibling && wrap.nextElementSibling.tagName !== 'H2') {
          wrap.appendChild(wrap.nextElementSibling);
        }
      }
    });

    // 2) Tablas con scroll horizontal
    Array.prototype.slice.call(rte.querySelectorAll('table')).forEach(function (tb) {
      if (tb.parentNode.classList.contains('iz-table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'iz-table-wrap';
      tb.parentNode.insertBefore(w, tb);
      w.appendChild(tb);
    });

    // 3) Índice lateral a partir de los h2
    var post = rte.closest('.iz-post');
    var toc = post && post.querySelector('[data-iz-toc]');
    var heads = Array.prototype.slice.call(rte.querySelectorAll('h2'));
    if (toc && heads.length >= 3) {
      var ol = toc.querySelector('ol');
      var links = [];
      heads.forEach(function (h, i) {
        if (!h.id) {
          h.id = 'iz-' + h.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'seccion-' + i;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
        links.push(a);
      });
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        var current = null;
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) current = e.target;
          });
          if (current) {
            links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + current.id); });
          }
        }, { rootMargin: '-10% 0px -70% 0px' });
        heads.forEach(function (h) { obs.observe(h); });
      }
    }
  });

  // 4) Barra de progreso de lectura
  var bars = document.querySelectorAll('.iz-progress span');
  if (bars.length) {
    var update = function () {
      var h = document.documentElement;
      var p = (h.scrollTop || document.body.scrollTop) / (h.scrollHeight - h.clientHeight || 1);
      bars.forEach(function (b) { b.style.width = Math.min(100, Math.max(0, p * 100)) + '%'; });
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // 5) Copiar enlace
  document.querySelectorAll('.iz-share__copy').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done);
      else { window.prompt('Copia el enlace:', url); }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', izInitBlogPost);
else izInitBlogPost();
